import React from 'react';

import {fakeDataOne, fakeDataTwo, fakeDataThree, fakeDataFour} from "./utilities";
import ChartCard from "./ChartCard.react";

const HoldingsCharts = ({showBySource}) => {
  return (
    <div className={'content'}>
      <ChartCard
        title={'Total Holdings'}
        assetPrice={12346590.95}
        asset={false}
        graphData={fakeDataOne}
        showBySource={showBySource}
      />
      <ChartCard
        title={'Bitcoin'}
        assetPrice={8346984.77}
        asset={{amount: 704, code: 'BTC'}}
        graphData={fakeDataTwo}
        showBySource={showBySource}
      />
      <ChartCard
        title={'Ethereum'}
        assetPrice={2799606.2}
        asset={{amount: 6719, code: 'ETH'}}
        graphData={fakeDataThree}
        showBySource={showBySource}
      />
      <ChartCard
        title={'Litecoin'}
        assetPrice={1199999.93}
        asset={{amount: 19005, code: 'LTC'}}
        graphData={fakeDataFour}
        showBySource={showBySource}
      />
    </div>
  )
}

export default HoldingsCharts;